const organisation = "HappyMilk";

const host = process.env.NODE_ENV === 'production' ? "http://webservice.sysbrew.in/happy_milk/" : "http://webservice.sysbrew.in/happy_milk/";
// const host = process.env.NODE_ENV === 'production' ? "http://mooservice.happymilk.co/" : "http://mooservice.happymilk.co/";

const Config = {
    token : "NjYzYzgyNzYyNGNmOWQzMmJjNzcxNjU2YTkwMDVmYjhlMDEzNGE3NThkNjExMWJjZWZhZGUwZGU1NDE2OGI1Ng==",
    get_routes: `${host}get_routes.php?organisation=${organisation}&`,
    get_routes_with_mapping: `${host}get_routes_with_mapping.php?organisation=${organisation}&`,
    get_detailed_routes: `${host}get_detailed_routes.php?organisation=${organisation}&`,
    remove_route: `${host}remove_route.php?organisation=${organisation}&`,
    remove_product: `${host}remove_product.php?organisation=${organisation}&`,
    create_route: `${host}create_route.php?organisation=${organisation}&`,
    route_scheduling_changes: `${host}route_scheduling_changes.php?organisation=${organisation}&`,
    assign_route: `${host}assign_route.php?organisation=${organisation}&`,
    assign_store_route: `${host}assign_store_route.php?organisation=${organisation}&`,
    get_route_area: `${host}get_route_area.php?organisation=${organisation}&`,
    get_store_deliveries_for_agent: `${host}get_store_deliveries_for_agent.php?organisation=${organisation}&`,
    remove_agent_assignment: `${host}remove_agent_assignment.php?organisation=${organisation}&`,
    remove_store_assignment: `${host}remove_store_assignment.php?organisation=${organisation}&`,
    authenticate_url: `${host}authenticate.php?organisation=${organisation}&`,
    get_products_url: `${host}get_products.php?organisation=${organisation}&`,
    create_product: `${host}create_product.php?organisation=${organisation}&`,
    save_product_order: `${host}save_product_order.php?organisation=${organisation}&`,
    mark_product_glass: `${host}mark_product_glass.php?organisation=${organisation}&`,
    get_agents_url: `${host}get_users.php?organisation=${organisation}&type=AGENT&`,
    get_stores_url: `${host}get_users.php?organisation=${organisation}&type=STORE&`,
    get_customers_url: `${host}get_users.php?organisation=${organisation}&type=CUSTOMER&`,
    get_userdetails_url: `${host}get_user_details.php?organisation=${organisation}&`,
    get_stores_export: `${host}get_stores_export.php?organisation=${organisation}&type=STORE&`,
    get_contracts_for_store: `${host}get_contracts_for_store.php?organisation=${organisation}&type=STORE&`,
    create_agent: `${host}create_agent.php?organisation=${organisation}&type=AGENT&`,
    create_store: `${host}create_store.php?organisation=${organisation}&type=STORE&`,
    create_customer: `${host}create_customer.php?organisation=${organisation}&type=CUSTOMER&`,
    remove_agent: `${host}remove_user.php?organisation=${organisation}&type=AGENT&`,
    remove_store: `${host}remove_user.php?organisation=${organisation}&type=STORE&`,
    update_bottles_returned: `${host}update_bottles_returned.php?organisation=${organisation}&`,    
    add_tag: `${host}add_tag.php?organisation=${organisation}&`,
    get_user_locations: `${host}get_user_locations.php?organisation=${organisation}&`,
    request_user_location: `${host}request_user_location.php?organisation=${organisation}&`,
    toggle_user_status: `${host}toggle_user_status.php?organisation=${organisation}&`,
    toggle_pause_state: `${host}toggle_pause_state.php?organisation=${organisation}&`,
    google_url: "http://maps.google.com?q=",
    get_roles: `${host}get_roles.php?organisation=${organisation}&`,
    total_count: `${host}total_count.php?organisation=${organisation}&`,
    get_statewise_delivery: `${host}get_statewise_delivery.php?organisation=${organisation}&`,
    get_customer_names: `${host}get_customer_names.php?organisation=${organisation}&`,
    update_pin: `${host}update_pin.php?organisation=${organisation}&`,
    update_store_contract: `${host}update_store_contract.php?organisation=${organisation}&`,
    get_uploaded_documents: `${host}get_uploaded_documents.php?organisation=${organisation}&`,
    get_available_states: `${host}get_available_states.php?organisation=${organisation}&`,
    export_excel: `${host}export_excel.php?organisation=${organisation}&`,
    mark_delivery: `${host}mark_delivery.php?organisation=${organisation}&`,
    mark_delivery_v2: `${host}mark_delivery_v2.php?organisation=${organisation}&`,
    notify_user_schedules_ready: `${host}notify_user_schedules_ready.php?organisation=${organisation}&`,
    notify_user_schedule_changes: `${host}notify_user_store_schedule_changes.php?organisation=${organisation}&`,
    get_store_routes: `${host}get_store_routes.php?organisation=${organisation}&`,
    save_store_route_order: `${host}save_store_route_order.php?organisation=${organisation}&`,
    save_store_route_order_v2: `${host}save_store_route_order_v2.php?organisation=${organisation}&`,
    get_store_delivery_schedule: `${host}get_store_delivery_schedules_new.php?organisation=${organisation}&`,
    get_customer_delivery_schedule: `${host}get_customer_delivery_schedules_new.php?organisation=${organisation}&`,
    get_store_deliveries: `${host}get_store_deliveries.php?organisation=${organisation}&`,
    get_customer_deliveries: `${host}get_customer_deliveries.php?organisation=${organisation}&`,
    get_store_delivery_pending_approval: `${host}get_store_delivery_pending_approval.php?organisation=${organisation}&`,
    approve_delivery_change: `${host}approve_delivery_change.php?organisation=${organisation}&`,
    get_store_delivery_schedule_marker: `${host}get_store_delivery_schedule_marker.php?organisation=${organisation}&`,
    create_delivery: `${host}create_delivery.php?organisation=${organisation}&`,
    remove_delivery: `${host}remove_delivery.php?organisation=${organisation}&`,
    resend_invoice: `${host}resend_invoice.php?organisation=${organisation}&`,
    resend_credit_note: `${host}resend_credit_note.php?organisation=${organisation}&`,
    list_invoice_details: `${host}list_invoice_details.php?organisation=${organisation}&`,
    get_indent: `${host}get_indent.php?organisation=${organisation}&`,
    get_indent_for_agent: `${host}get_indent_for_agent.php?organisation=${organisation}&`,
    check_schedule_exists: `${host}check_schedule_exists.php?organisation=${organisation}&`,
    report_daily_delivery_status: `${host}report_daily_delivery_status.php?organisation=${organisation}&`,
    report_store_earnings: `${host}report_store_earnings.php?organisation=${organisation}&`,
    update_template: `${host}update_template.php?organisation=${organisation}&`,
    update_delivery_grn: `${host}update_delivery_grn.php?organisation=${organisation}&`,

    // import
    upload_map_url: `${host}upload_map.php?organisation=${organisation}&`,
    upload_product_url: `${host}upload_product_image.php?organisation=${organisation}&`,
    upload_url: `${host}import_schedule.php?organisation=${organisation}&`,
    upload_ledger_url: `${host}import_ledger.php?organisation=${organisation}&`,
    reassign_routes: `${host}reassign_routes_as_per_mapping.php?organisation=${organisation}&`,
    get_predictions: `${host}get_predictions.php?organisation=${organisation}&`,

    // Promotions
    get_promotions_url: `${host}get_promotions.php?organisation=${organisation}&`,
    get_promotiondetails: `${host}get_promotiondetails.php?organisation=${organisation}&`,
    toggle_promotion_status: `${host}toggle_promotion_status.php?organisation=${organisation}&`,
    create_promotion: `${host}create_promotion.php?organisation=${organisation}&`,
    remove_promotion: `${host}remove_promotion.php?organisation=${organisation}&`,

    // Reports
    report_summary:`${host}report_summary.php?organisation=${organisation}&`,
    report_schedule:`${host}report_schedule.php?organisation=${organisation}&`,
    report_max : `${host}report_max.php?organisation=${organisation}&`,
    report_pending_bottles:`${host}report_pending_bottles.php?organisation=${organisation}&`,
    report_pending_bottles_detailed: `${host}report_pending_bottles_detailed.php?organisation=${organisation}&`,
    report_sales_stats: `${host}report_sales_stats.php?organisation=${organisation}&`,
    get_customer_transactions: `${host}get_customer_transactions.php?organisation=${organisation}&`,
    get_agent_transactions: `${host}get_agent_transactions.php?organisation=${organisation}&`,
    get_agent_transactions_summary: `${host}get_agent_transactions_summary.php?organisation=${organisation}&`,
    get_agent_transactions_summary_mismatch_txn: `${host}get_agent_transactions_summary_mismatch_txn.php?organisation=${organisation}&`,
    report_sales_report: `${host}sales_report.php?organisation=${organisation}&`,
    report_store_b2w: `${host}report_store_b2w.php?organisation=${organisation}&`,
    report_product_trend_by_user: `${host}report_product_trend_by_user.php?organisation=${organisation}&`,
    report_store_sales_by_user: `${host}report_store_sales_by_user.php?organisation=${organisation}&`,
    report_performance_by_user: `${host}report_performance_by_user.php?organisation=${organisation}&`,
    report_product_stats_by_user: `${host}report_product_stats_by_user.php?organisation=${organisation}&`,
    report_product_sales_stats_by_user: `${host}report_product_sales_stats_by_user.php?organisation=${organisation}&`,
    report_store_export: `${host}report_store_export.php?organisation=${organisation}&`,
    report_stores_inactive_by_orders: `${host}report_stores_inactive_by_orders.php?organisation=${organisation}&`,
    report_stores_no_orders: `${host}report_stores_no_orders.php?organisation=${organisation}&`,
    report_stores_with_no_recent_orders: `${host}report_stores_with_no_recent_orders.php?organisation=${organisation}&`,
    get_unattended_stores: `${host}get_unattended_stores.php?organisation=${organisation}&`,
    store_delivery_status: `${host}get_daily_delivery_status.php?organisation=${organisation}&`,
    get_store_shelf_stats: `${host}get_store_shelf_stats.php?organisation=${organisation}&`,
    report_store_outstanding: `${host}report_store_outstanding.php?organisation=${organisation}&`,
    report_agent_performance_graph: `${host}report_agent_performance_graph.php?organisation=${organisation}&`,

    // Tools
    send_notification: `${host}generic_send_notification.php?organisation=${organisation}&`,
    get_reason_by_type: `${host}get_reason_by_type.php?organisation=${organisation}&`,
    create_reason: `${host}create_reason.php?organisation=${organisation}&`,
    remove_reason: `${host}remove_reason.php?organisation=${organisation}&`,
    get_organisation_details: `${host}get_organisation_details.php?organisation=${organisation}&`,
    update_organisation_information: `${host}update_organisation_information.php?organisation=${organisation}&`,
    reset_invoice_no: `${host}reset_invoice_no.php?organisation=${organisation}&`,
    reset_payment_no: `${host}reset_payment_no.php?organisation=${organisation}&`,
    reset_credit_note_no: `${host}reset_credit_note_no.php?organisation=${organisation}&`,
    get_activities: `${host}get_activities.php?organisation=${organisation}&`,
    enable_auto_scheduling: `${host}enable_auto_scheduling.php?organisation=${organisation}&`,
    enable_due_check: `${host}enable_due_check.php?organisation=${organisation}&`,

    // WareHouse
    get_warehouses_url: `${host}get_warehouses.php?organisation=${organisation}&`,
    get_warehouse_stock_url: `${host}get_warehouse_stock.php?organisation=${organisation}&`,
    remove_wh: `${host}remove_wh.php?organisation=${organisation}&`,
    remove_wh_reason: `${host}remove_wh_reason.php?organisation=${organisation}&`,
    remove_wh_reason_ownership: `${host}remove_wh_reason_ownership.php?organisation=${organisation}&`,
    assign_wh_reason_ownership: `${host}assign_wh_reason_ownership.php?organisation=${organisation}&`,
    create_wh_reason: `${host}create_wh_reason.php?organisation=${organisation}&`,
    create_wh: `${host}create_wh.php?organisation=${organisation}&`,
    toggle_wh_status: `${host}toggle_wh_status.php?organisation=${organisation}&`,
    get_inventory_transactions: `${host}get_inventory_transactions.php?organisation=${organisation}&`,
    get_inventory_transaction_details: `${host}get_inventory_transaction_details.php?organisation=${organisation}&`,
    get_inventory_transactions_for_sd: `${host}get_inventory_transactions_for_sd.php?organisation=${organisation}&`,
    create_inventory_transaction: `${host}create_inventory_transaction.php?organisation=${organisation}&`,
    update_inventory_mismatch: `${host}update_inventory_mismatch.php?organisation=${organisation}&`,
    get_inventory_summary: `${host}get_inventory_summary.php?organisation=${organisation}&`,
    get_inventory_batchwise_summary: `${host}get_inventory_batchwise_summary.php?organisation=${organisation}&`,
    remove_inventory_transaction: `${host}remove_inventory_transaction.php?organisation=${organisation}&`,
    get_warehouse_reasons_url: `${host}get_warehouse_reasons.php?organisation=${organisation}&`,
    report_daily_inventory_url: `${host}report_daily_inventory.php?organisation=${organisation}&`,
    report_inventory_opening_stock_url: `${host}report_inventory_opening_stock.php?organisation=${organisation}&`,
    report_inventory_mismatch_stock_url: `${host}report_inventory_mismatch_stock.php?organisation=${organisation}&`,
    daily_inventory_report_url: `${host}report_special_stock_summary.php?organisation=${organisation}&`,
    trigger_b2b_scheduler_url: `${host}trigger_schedule_job.v2.php?organisation=${organisation}&trigger=manual&`,

    // Payment
    update_payment: `${host}update_payment_details.php?organisation=${organisation}&`,
    get_payment_transactions : `${host}get_payment_transactions.php?organisation=${organisation}&`,

    // summary
    get_route_summary: `${host}get_route_summary.php?organisation=${organisation}&`,
    get_route_summary_detailed: `${host}get_route_summary_detailed.php?organisation=${organisation}&`,
    get_route_summary_export: `${host}get_route_summary_export.php?organisation=${organisation}&`,
    get_turnover_summary: `${host}get_turnover_summary.php?organisation=${organisation}&`,
    get_returnsvalue_summary: `${host}get_returnsvalue_summary.php?organisation=${organisation}&`,
    get_returns_summary: `${host}get_returns_summary.php?organisation=${organisation}&`,

    //Returns
    report_returns_by_route: `${host}report_returns_by_route.php?organisation=${organisation}&`,
    report_returns_by_store: `${host}report_returns_by_store.php?organisation=${organisation}&`,

    //Notifications
    register_fcm_url: `${host}registerfornotifications.php?organisation=${organisation}&`,
    unregister_fcm_url: `${host}unregister_notification.php?organisation=${organisation}&`,

    // Job
    get_jobs: `${host}list_jobs.php?organisation=${organisation}&`,
    get_job_detail: `${host}get_job_detail.php?organisation=${organisation}&`,

    defaultAlerts: {
        import: {
            hr: "18",
            min: "0"
        }
    },

    REFRESH_INTERVAL: 300000,

    whatsapp_link: 'https://wa.me/{{mobile}}?text=',
}

export default Config;

export const RowCountOptions = [10, 25, 50, 100];